import {Component, OnInit, ViewChild} from '@angular/core';
import {UserPreferencesService} from './modules/shared/service/user-preferences.service';
import {TranslateService} from '@ngx-translate/core';
import {LocalizationService} from './modules/shared/service/localization.service';
import {BuildingsService} from './modules/shared/service/buildings.service';
import {AuthorizationService} from './modules/shared/service/authorization.service';
import {LoggerService} from './service/logger.service';
import {FreshdeskWidgetManager, RequestErrorModalComponent} from '@npm.chapps.com/chapps.common.angular.library';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  @ViewChild(RequestErrorModalComponent) errorModal: RequestErrorModalComponent;
  public areTranslationsLoading: boolean;

  constructor(private userPreferencesService: UserPreferencesService, private translate: TranslateService,
              private localizationService: LocalizationService, private buildingsService: BuildingsService,
              private authorizationService: AuthorizationService, private loggerService: LoggerService,
              private widgetManager: FreshdeskWidgetManager) {}

  ngOnInit() {
    this.areTranslationsLoading = true;
    this.initErrorModal();
    this.initServices();
    this.refreshSessionIfSignedIn();
    this.translate.onLangChange.subscribe((language) => this.widgetManager.initalise(language.lang));
    this.translate.use(this.localizationService.getStartingLanguage()).subscribe(() => this.areTranslationsLoading = false);
  }

  public getFont(): string {
    return this.userPreferencesService.getFont();
  }

  public getTextColor(): string {
    return this.userPreferencesService.getTextColor();
  }

  private initErrorModal() {
    this.loggerService.error$.subscribe(() => this.errorModal.show());
  }

  private initServices() {
    this.buildingsService.init();
  }

  private refreshSessionIfSignedIn() {
    if (this.authorizationService.isUserLoggedIn()) {
      this.authorizationService.refreshSession();
    }
  }
}
